export type DevicePropertyName = string;
export type DeviceProperties = Record<DevicePropertyName, any>;
export type DeviceRequirements = DeviceProperties;

/**
 * Sort accordingly to the property key.
 *
 * TODO check device property names due to refactoring in openstf reporter (WMKNBN-6575)
 */
export const DevicePropertyNames = {
    AutomationAvailable: 'automation.available',
    AutomationEnabled: 'automation.available',
    ActiveVehicles: 'automation.activeVehicles',
    MaxExpeditionCapacity: 'automation.maxExpeditionCapacity',
    CDPAvailable: 'cdp.available',

    InstalledPackages: 'package.installedPackages',

    AudioStreamingAvailable: 'streaming.audio.available',
    AudioStreamingInfo: 'streaming.audio.info',
    AudioStreamingRequested: 'streaming.audio.requested',

    SimulateBandwidth: 'network.simulation.bandwidth',
    SimulatePaketLoss: 'network.simulation.packetloss',
    SimulateDisconnect: 'network.simulation.disconnect',

    SimulateGPS: 'sensorsimulation.gps',
    SimulateBiometrics: 'sensorsimulation.simulateBiometrics',
    BiometricAuthentication: 'sensorsimulation.acceptBiometricAuthentication',
    SimulateCamera: 'sensorsimulation.simulateCamera',
    MediaSettings: 'settings.media',

    Resolution: 'console.resolution',
    ChangeResolution: 'console.changeResolution',
    Console: 'console.interactive',

    Locale: 'os.locale',
    Language: 'os.language',
    CanInstallPackages: 'os.canInstallPackages',

    IP: 'network.ip',
    SetupDone: 'webmate.setup',

    ManufacturerName: 'machine.manufacturer',
    ModelName: 'machine.model',
    MachineBrowsers: 'machine.browsers',
    MachinePlatform: 'machine.platform',
    MachinePlatformType: 'machine.platform.type',
    MachinePoolId: 'machine.pool.id',
    MachineId: 'machine.id',
    MacvirtTemplateId: 'macvirt.template.id',

    MobileBridgeRunning: 'mobileBridge.running',

    Annotations: 'machine.annotations',
    UserAnnotations: 'machine.userAnnotations',

    DeviceId: 'webmate.deviceId',
    ProviderType: 'webmate.providerType',
    ProviderId: 'webmate.providerId',
    SlotId: 'webmate.slotId',
    Unavailable: 'webmate.deviceUnavailable',
    DeviceOfferId: 'webmate.deviceOfferId',

    StateRevertToInitial: 'state.revertToInitial',
    StateRevertToSnapshot: 'state.revertToSnapshot',
    StateCreateSnapshot: 'state.createSnapshot',
    StateReconnect: 'state.reconnect',
    StateReset: 'state.reset',

    StartUpScriptState: 'webmate.startupScriptState',

    SeleniumNode: 'selenium.node',

    OpenSTFSerial: 'openstf.serial',
    OpenSTFSimCardInfo: 'openstf.simcardinfo',

    VCloudTemplateId: 'vcloud.templateId',
    VCloudTemplateGroup: 'vcloud.template.group',
    VCloudState: 'vcloud.state',

    IOSInteractionType: 'machine.iOSInteractionType',

    ScreenSecurity: 'instrumentation.screenSecurity',
    KeychainBypass: 'instrumentation.keychainBypass',
};

export type PlatformFamily = 'mobile' | 'desktop';

export function getPlatformFamily(props: DeviceProperties): PlatformFamily {
    const platformType = props[DevicePropertyNames.MachinePlatformType];
    if (platformType?.toLowerCase() === 'android' || platformType?.toLowerCase() === 'ios') {
        return 'mobile';
    } else {
        return 'desktop';
    }
}
